<template>
  <div class="sub-theme">
    <b-row class="subtheme-head">
      <span class="btn-collapse" @click="expand=!expand" v-if="!printMode">
        <chevron-right-icon  v-if="!expand" :title="$t('views.themeView.subTheme.expandTitle')" />
        <chevron-down-icon v-if="expand"  :title="$t('views.themeView.subTheme.collapseTitle')" />
      </span>

      <h5 class="subtitle" @click="expand=!expand">
        {{subTheme.title}}
      </h5>

      <span class="edit-btns" v-if="subTheme.custom && edit">
        <b-button variant="link" class="link-btn" @click="showAddElementPopin()">
          <lead-pencil-icon title="" />{{$t('views.themeView.subTheme.renameBtn')}}
        </b-button>
        <b-button variant="link" class="link-btn" @click="showDeletePopin()">
          <inrs-delete-icon title="" />{{$t('views.themeView.subTheme.deleteBtn')}}
        </b-button>
      </span>
    </b-row>
    <b-row><h5 class="evaluation-title">{{$t('views.themeView.subTheme.rating.yourEvaluation')}}</h5></b-row>
    <b-row class="evaluation-row">
      <div class="evaluation-col">
        <b-form-radio-group :disabled="printMode" class="myradio theme-radio" plain v-model="selectedRatingOption" :options="ratingOptions"></b-form-radio-group>
      </div>
      <div class="progressbar-col" :style="{opacity:selectedRatingOption.style}" :key="reRenderKey">
        <progress-bar v-if="!printMode"
          :themeAbbr="themeAbbr"
          :idRef="subTheme.ref.split('.').join('')"
          :subThemeRef="subTheme.ref"
          :rating="subTheme.rating"
          :disabled="selectedRatingOption.disabled"
          type="SUBTHEME"
          v-on:ratingDone="selectedRatingOption={value: null, disabled: false, style: 1}, $emit('ratingChanged')"
        ></progress-bar>

        <!-- progress-bar en mode impression -->
        <progress-bar v-if="printMode"
          :themeAbbr="themeAbbr"
          :idRef="'print'+subTheme.ref.split('.').join('')"
          :subThemeRef="subTheme.ref"
          :rating="subTheme.rating"
          :disabled="true"
          type="PRINT"
        ></progress-bar>
      </div>
      <div class="empty-col"></div>
    </b-row>
    <b-collapse v-model="expand" :id="'collapse-'+id" class="mt-2">
      <levels-section v-if="subTheme.situationDescriptions.length || edit"
        :edit="edit"
        :themeAbbr="themeAbbr"
        :subThemeRef="subTheme.ref"
        :contentList="subTheme.situationDescriptions"
        data-type="OBSERVATIONS"
        :printMode="printMode"
      ></levels-section>
      <info-message v-if="!subTheme.situationDescriptions.length && !printMode && !edit" :text="$t('views.themeView.subTheme.msgDescriptionsEmpty')"/>
      <info-message v-if="!subTheme.situationDescriptions.length && printMode" :text="$t('views.themeView.subTheme.msgPrintDescriptionsEmpty')"/>
    </b-collapse>
  </div>
</template>

<script>
import ProgressBar from "../ProgressBar";
import LevelsSection from "./LevelsSection";
import LeadPencilIcon from 'vue-material-design-icons/LeadPencil.vue';
//import PlusBoxOutlineIcon from 'vue-material-design-icons/PlusBoxOutline.vue';
//import MinusBoxOutlineIcon from 'vue-material-design-icons/MinusBoxOutline.vue';
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import InrsDeleteIcon from '../../icons/InrsDelete.vue';
import InfoMessage from "../global/InfoMessage.vue";

export default {
  name: "SubThemeSection",
  components: {
    ProgressBar,
    LevelsSection,
    LeadPencilIcon,
    InrsDeleteIcon,
    //PlusBoxOutlineIcon,
    //MinusBoxOutlineIcon,
    ChevronRightIcon,
    ChevronDownIcon,
    InfoMessage
  },
  props: {
    themeAbbr: String, // savoir dans quel thème on se situe
    subTheme: Object, // données à traiter
    id: Number, // nommer les evenements liés aux collapses
    edit: Boolean, // afficher les colonnes en mode edition ou non
    printMode: {
      type: Boolean,
      default: false
    },
    index: Number,
    subThemeInitLength: Number // detecter l'ajout d'un sous-thème
  },
  watch: {
    selectedRatingOption: function() {
      var newData = {}
      if (this.selectedRatingOption == this.ratingOptions[0].value) { 
        // Passage à "Non concerné" :
        // on met la note liée à ce sous-thème à -1 pour signifier que l'utilisateur a coché "non concerné"
        newData = {
          type: "RATE-SUBTHEME",
          params: {
            themeAbbr: this.themeAbbr,
            subThemeRef: this.subTheme.ref,
            rating: -1
          }
        };
        this.$store.dispatch("editThemeElement", newData);
        this.$emit('ratingChanged') // on notifie que la note a changé afin de recalculer globalRating
        this.reRenderKey+=1 // on demande à vuejs de regénérer le composant quand "rating" lié au slider change car Jquery est non réactif 
      }
      else if (this.selectedRatingOption == this.ratingOptions[1].value) { // à évaluer
        // Passage à "A évaluer" :
        newData = {
          type: "RATE-SUBTHEME",
          params: {
            themeAbbr: this.themeAbbr,
            subThemeRef: this.subTheme.ref,
            rating: null
          }
        };
        this.$store.dispatch("editThemeElement", newData);
        this.$emit('ratingChanged') // on notifie que la note a changé afin de recalculer globalRating
        this.reRenderKey+=1 // on demande à vuejs de regénérer le composant quand "rating" lié au slider change car Jquery est non réactif 
      }
    }
  },
  data: function() {
    return {
      reRenderKey: 0,
      expand: true, // MODIF https://jira.inrs.fr/browse/GPSST-3
      selectedRatingOption: { value: false, disabled: false, style: 1 },
      ratingOptions: [
        {
          text: this.$i18n.t('views.themeView.subTheme.rating.options.notConcerned'),
          value: { value: true, disabled: true, style: 0.5 }
        },
        {
          text: this.$i18n.t('views.themeView.subTheme.rating.options.toRate'),
          value: { value: false, disabled: false, style: 1 }
        }
      ]
    };
  },
  mounted: function() {
    // DEBUT MODIF https://jira.inrs.fr/browse/GPSST-3
    /*
    if (this.id === 0  || this.printMode) {
      // on déplie par defaut le premier sous-theme
      this.expand = true;
    }
    // déplier les nouveaux sous-thèmes
    if(this.index >= this.subThemeInitLength) {
      this.expand = true;
    }
    */
    // FIN MODIF https://jira.inrs.fr/browse/GPSST-3

    if (this.subTheme.rating > 0) {
      this.selectedRatingOption = { value: null, disabled: false, style: 1 };
    }
    else if (this.subTheme.rating == -1) {
      this.selectedRatingOption = this.ratingOptions[0].value;
    }
  },
  methods: {
    showDeletePopin: function() {
      this.$store.commit("SET_POPIN", {
        themeAbbr: this.themeAbbr,
        subThemeRef: this.subTheme.ref,
        type: "DEL-SUBTHEME"
      });
      this.$bvModal.show("deleteElement");
    },
    showAddElementPopin: function() {
      this.$store.commit("SET_POPIN", {
        themeAbbr: this.themeAbbr,
        subThemeRef: this.subTheme.ref,
        description: this.subTheme.title,
        type: "RENAME-SUBTHEME"
      });
      this.$bvModal.show("addThemeElement");
    }
  }
};
</script>

<style lang="sass" scoped>
@import "../../sass/_variables.sass"
@import "../../sass/media.sass"

.sub-theme
  background: $lightgray-3
  border: 2px solid white
  padding: 1em

  @media print
    background: #fff
    padding: 0
    break-inside: avoid
    page-break-inside: avoid

  .row
    margin: 0
    @media print
      margin: 0

  .subtheme-head
    flex-wrap: nowrap
    position: relative
    align-items: baseline

    @media print
      margin: 0

    .btn-collapse
      position: relative
      top: -0.1em
      cursor: pointer
      min-width: 1.7em

    .subtitle
      color: $darkgray-3
      cursor: pointer
      flex-grow: 100

    .edit-btns
      flex-grow: 1  
      white-space: nowrap

      button
        margin: 0 0 0 1em

  .evaluation-title
    font-weight: bold
    font-size: 1.23rem
    margin-left: 1.5em

    @media print
      display: none

  .evaluation-row
    align-items: baseline
    user-select: none
    margin: 0 0.7em 0 1.85em

    @media print
      margin: 0

    .evaluation-col
      flex-grow: 0
      
      @include sm 
        width: 100%

      @media print
        flex-grow: 0

      .theme-radio
        margin: 0

        ::v-deep .form-check
          margin: 0 1.5em 0 0
          font-weight: bold
    
    .progressbar-col
      flex-grow: 5
    
    .empty-col
      flex-grow: 6
      @include md 
        display: none


  .link-btn
    color: $darkgray-3
    padding-left: 0
    font-weight: bold
    &:hover, &:focus
      color: $darkgray-3


</style>

